// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-bank[data-v-c1b424d0]{display:flex;grid-gap:var(--spaces-m);align-items:center;justify-content:center}.footer-bank__list[data-v-c1b424d0]{display:flex;grid-gap:var(--spaces-s)}.footer-bank__image[data-v-c1b424d0]{flex:0 0 auto;width:48px;height:48px}.footer-bank__white-text[data-v-c1b424d0]{color:var(--neutral-300)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
